

import DataStore from '../services/data-store';
import { base_url } from '../services/constants';
import growl from '../services/growl';
import ShopService from '../services/shop-service';

export default {
	data() {
		return {
			processing: false,
			processingImages: false,
			scrapingResult: null,
			imageResult: null,
            menu_url: '',
		};
	},
	methods: {
		scrape() {
			this.processing = true;
			this.scrapingResult = null;
			DataStore.get(base_url + '/admin/deliveroo/scrape?menu_url=' + this.menu_url + '&ShopId=' + ShopService.shop.ShopId,"Erreur lors de l'importation")
			.then((data) => this.scrapingResult = data.msg)
			.finally(()=>this.processing = false);
		},
		scrapeImages() {
			this.processingImages = true;
			this.imageResult = null;
			DataStore.get(base_url + '/admin/deliveroo/scrape-images?ShopId=' + ShopService.shop.ShopId,"Erreur lors de l'importation des images")
			.then((data) => this.imageResult = data.msg)
			.finally(()=>this.processingImages = false);
		},
	}
}
